/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Typography2, breakpoints, useMediaQuery } from '@coursera/cds-core';

import CourseraIconSVG from 'bundles/enterprise-learning-path-description-page/assets/CourseraIconSVG';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const styles = {
  item: css`
    display: flex;
    gap: var(--cds-spacing-200);
  `,
  iconContainer: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  title: css`
    margin-bottom: var(--cds-spacing-50);
  `,
  description: css`
    max-width: 608px;
  `,
};

const CareerCertificateItem = () => {
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  return (
    <div css={styles.item}>
      <div css={styles.iconContainer}>
        <CourseraIconSVG />
      </div>
      <div>
        <Typography2 component="h3" variant={isMobile ? 'subtitleMedium' : 'subtitleLarge'} css={styles.title}>
          {_t('Earn a certificate')}
        </Typography2>
        <Typography2
          component="p"
          variant={isMobile ? 'bodySecondary' : 'bodyPrimary'}
          css={styles.description}
          color="supportText"
        >
          {_t(
            'Complete the skill assessments in each section to verify your mastery and earn a certificate. Showcase your accomplishment by adding it to your resume or LinkedIn Profile!'
          )}
        </Typography2>
      </div>
    </div>
  );
};

export default CareerCertificateItem;
